/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import feedbackEndpoints from '../feedback'



const authBasePath = '/membership/payments'

const paymentsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchPayments: builder.query<any, {pageNumber: number}>({
    query: ({pageNumber}) => ({
      url: `${authBasePath}?size=10&page=${pageNumber}`,
      method: 'get',
    }),
    providesTags: ['payments'],
  }),

  fetchLedger: builder.query<any, {
    page?: number;
    size?: number;
    startDate?: string;
    endDate?: string;
    kind?: string;
    accountId?: number | string;
    cleared?: boolean | null;
    sortBy?: string;
    sortDir?: 'asc' | 'desc';
  }>({
    query: ({ page = 0, size = 10, startDate, endDate, kind, accountId, cleared, sortBy, sortDir } = {}) => {
      const params = new URLSearchParams()
      params.set('page', String(page))
      params.set('size', String(size))
      if (startDate) params.set('startDate', startDate)
      if (endDate) params.set('endDate', endDate)
      if (kind && kind !== 'ALL') params.set('kind', kind)
      if (accountId !== undefined && accountId !== '' && accountId !== null) params.set('accountId', String(accountId))
      if (cleared !== undefined && cleared !== null) params.set('cleared', String(cleared))
      if (sortBy) params.set('sortBy', sortBy)
      if (sortDir) params.set('sortDir', sortDir)
      return {
        url: `${authBasePath}/ledger?${params.toString()}`,
        method: 'get',
      }
    },
    providesTags: ['payments', 'variable-expenses', 'fixed-expenses'],
  }),

  reviewPayment: builder.mutation<any, { paymentId: string; accountId: number; feeAmount?: number }>({
    query: ({ paymentId, accountId, feeAmount = 0 }) => ({
      url: `${authBasePath}/${paymentId}/review`,
      method: 'post',
      body: { accountId, feeAmount },
    }),
    invalidatesTags: ['payments', 'running-dashboard'],
  }),

  updateReviewedPayment: builder.mutation<any, { paymentId: string; accountId: number; feeAmount?: number }>({
    query: ({ paymentId, accountId, feeAmount = 0 }) => ({
      url: `${authBasePath}/${paymentId}/review`,
      method: 'put',
      body: { accountId, feeAmount },
    }),
    invalidatesTags: ['payments', 'running-dashboard'],
  }),

  fetchRevenueReport: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${authBasePath}/revenue?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),

  fetchRevenueCustomers: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${authBasePath}/revenue/customers?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),
})

export default paymentsEndpoints



